module.exports = __webpack_public_path__ + "img/user-manage.ce9ae304.png";